import { MagnifyingGlassIcon } from '@phosphor-icons/react'
import type { ReactElement } from 'react'
import { EmptySearch } from 'app/components/shared/styled/EmptySearch'

export const EMPTY_HEADLINE = `Find a contact, activity, or page`
export const EMPTY_HINT = `Search by name, phone number, or email`

const KEY_HINTS: ReadonlyArray<{ keys: readonly string[]; label: string }> = [
  { keys: [`↑`, `↓`], label: `navigate` },
  { keys: [`↵`], label: `open` },
  { keys: [`esc`], label: `close` },
]

/** What the palette shows before anything is typed: an invitation, not a list. */
export function PaletteEmptyState(): ReactElement {
  return (
    <div className="flex flex-col items-center px-6 pt-10 pb-6 text-center">
      <EmptySearch
        title={EMPTY_HEADLINE}
        description={EMPTY_HINT}
        icon={() => (
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-surface-muted text-subtle">
            <MagnifyingGlassIcon size={22} weight="bold" />
          </div>
        )}
      />
      <div className="mt-8 flex items-center gap-4 text-[11px] text-minimal">
        {KEY_HINTS.map((hint) => (
          <span key={hint.label} className="flex items-center gap-1.5">
            <span className="flex gap-0.5">
              {hint.keys.map((key) => (
                <kbd
                  key={key}
                  className="min-w-[20px] rounded border border-default bg-surface px-1 py-0.5 text-center font-sans text-[10px] text-subtle"
                >
                  {key}
                </kbd>
              ))}
            </span>
            {hint.label}
          </span>
        ))}
      </div>
    </div>
  )
}
